import React from "react";
import ReactDOM, { Container } from "react-dom/client";
import "./index.css";
import App from "./App";
import "@mantine/core/styles.css";
import {
  ActionIcon,
  MantineProvider,
  useMantineColorScheme,
} from "@mantine/core";
import ThemeToggle from "./components/ThemeToggle/ThemeToggle";

const root = ReactDOM.createRoot(document.getElementById("root") as Container);
root.render(
  <React.StrictMode>
    <MantineProvider defaultColorScheme="light">
      <App />
    </MantineProvider>
  </React.StrictMode>
);
